import AccountSettings from "./accountSettings.json"

let settings = AccountSettings

export const getLayoutType = authenticAccountId => {
  return getAccountSettings(authenticAccountId).settings.style["content"]
}

export const setUpAccountSettings = newSettings => {
  if (!newSettings || !newSettings.authentic_account_id) {
    return
  }

  if (!settings) {
    settings = {}
  }

  settings[String(newSettings.authentic_account_id)] = newSettings
}

const setFavIcon = faviconUrl => {
  if (!faviconUrl) return

  let link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link")
  link.type = "image/x-icon"
  link.rel = "shortcut icon"
  link.href = faviconUrl
  document.getElementsByTagName("head")[0].appendChild(link)
}

export const getAccountSettings = authenticAccountId => {
  if (!authenticAccountId) {
    authenticAccountId = "default"
  }

  if (typeof window !== "undefined" && window.accountSettings) {
    const { favicon } = window.accountSettings
    const { url } = favicon || {}
    setFavIcon(url || "")

    return {
      ...AccountSettings.default,
      ...window.accountSettings,
      settings: {
        ...AccountSettings.default.settings,
        ...window.accountSettings.settings
      }
    }
  } else {
    if (!settings[String(authenticAccountId)]) {
      return {
        ...AccountSettings.default
      }
    }

    return {
      ...AccountSettings.default,
      ...settings[String(authenticAccountId)],
      settings: {
        ...AccountSettings.default.settings,
        ...settings[String(authenticAccountId)].settings
      }
    }
  }
}



// WEBPACK FOOTER //
// ./webapp/scripts/accountSettings.js